module.exports = __webpack_public_path__ + "static/media/thumbnail.28953585.jpg";